import { EventType } from '@azure/msal-browser';
import React from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './App';
import { msalInstance } from './services/msal';

import type { AuthenticationResult, EventMessage } from '@azure/msal-browser';

// if (import.meta.env.DEV) {
// 	const { worker } = await import('./app/mock/browser');
// 	await worker.start({
// 		onUnhandledRequest: 'bypass',
// 	});
// }

void msalInstance.initialize().then(() => {
	// Account selection logic is app dependent. Adjust as needed for different use cases.
	const accounts = msalInstance.getAllAccounts();
	if (accounts.length > 0) {
		msalInstance.setActiveAccount(accounts[0]);
	}

	msalInstance.addEventCallback((event: EventMessage) => {
		if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
			const payload = event.payload as AuthenticationResult;
			const account = payload.account;
			msalInstance.setActiveAccount(account);
		}
	});

	const container = document.getElementById('root');
	const root = createRoot(container!);

	root.render(
		<React.StrictMode>
			<App />
		</React.StrictMode>
	);
});
